// src/components/HyperText.jsx
import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';

const DEFAULT_CHARACTER_SET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789".split("");

const getRandomInt = (max) => Math.floor(Math.random() * max);

export const HyperText = ({
  children,
  isAnimating: externalIsAnimating,
  className = "",
  duration = 600,
}) => {
  const [displayText, setDisplayText] = useState(() => children.split(""));
  const [isAnimating, setIsAnimating] = useState(false);
  const iterationCount = useRef(0);

  // Reset animation when external trigger changes
  useEffect(() => {
    if (externalIsAnimating && !isAnimating) {
      iterationCount.current = 0;
      setIsAnimating(true);
    }
  }, [externalIsAnimating, isAnimating]);

  // Handle scramble animation
  useEffect(() => {
    if (!isAnimating) return;

    const intervalDuration = duration / (children.length * 10);
    const maxIterations = children.length;

    const interval = setInterval(() => {
      if (iterationCount.current < maxIterations) {
        setDisplayText((currentText) =>
          currentText.map((letter, index) =>
            letter === " "
              ? letter
              : index <= iterationCount.current
                ? children[index]
                : DEFAULT_CHARACTER_SET[getRandomInt(DEFAULT_CHARACTER_SET.length)]
          )
        );
        iterationCount.current = iterationCount.current + 0.1;
      } else {
        setIsAnimating(false);
        clearInterval(interval);
      }
    }, intervalDuration);

    return () => clearInterval(interval);
  }, [children, duration, isAnimating]);

  return (
    <AnimatePresence>
      {displayText.map((letter, index) => (
        <motion.span
          key={index}
          className={`font-mono ${letter === " " ? "w-3" : ""} ${className}`}
        >
          {letter.toUpperCase()}
        </motion.span>
      ))}
    </AnimatePresence>
  );
};